const { billetCodeType } = require('@transfeeradev/api-enums');

module.exports = class GetCodeTypeService {
  static get(code) {
    if (typeof code !== 'string') {
      throw new Error('code needs to be a string');
    }

    if (code.length === 44) {
      return billetCodeType.BARCODE;
    } else if (code.length === 47 || code.length === 48) {
      return billetCodeType.DIGITABLE;
    }

    throw new Error('Invalid code');
  }
};
